import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRooftopUsersQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetRooftopUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, display_name: string, email?: string | null }> };


export const GetRooftopUsersDocument = gql`
    query GetRooftopUsers($customerId: bigint!) {
  users(
    where: {active: {_eq: true}, default_role: {_in: ["dealer", "dealer-admin", "dealer-super-admin"]}, _or: [{customer_id: {_eq: $customerId}}, {users_usertocustomers: {customer_id: {_eq: $customerId}}}]}
    order_by: {display_name: asc}
  ) {
    id
    display_name
    email
  }
}
    `;

/**
 * __useGetRooftopUsersQuery__
 *
 * To run a query within a React component, call `useGetRooftopUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRooftopUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRooftopUsersQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetRooftopUsersQuery(baseOptions: Apollo.QueryHookOptions<GetRooftopUsersQuery, GetRooftopUsersQueryVariables> & ({ variables: GetRooftopUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>(GetRooftopUsersDocument, options);
      }
export function useGetRooftopUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>(GetRooftopUsersDocument, options);
        }
// @ts-ignore
export function useGetRooftopUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>;
export function useGetRooftopUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRooftopUsersQuery | undefined, GetRooftopUsersQueryVariables>;
export function useGetRooftopUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>(GetRooftopUsersDocument, options);
        }
export type GetRooftopUsersQueryHookResult = ReturnType<typeof useGetRooftopUsersQuery>;
export type GetRooftopUsersLazyQueryHookResult = ReturnType<typeof useGetRooftopUsersLazyQuery>;
export type GetRooftopUsersSuspenseQueryHookResult = ReturnType<typeof useGetRooftopUsersSuspenseQuery>;
export type GetRooftopUsersQueryResult = Apollo.QueryResult<GetRooftopUsersQuery, GetRooftopUsersQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/products/settingsHost/getRooftopUsers.query.gql}
 */
export async function getRooftopUsers(
  variables: GetRooftopUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRooftopUsersQuery['users']>
export async function getRooftopUsers(
  variables: GetRooftopUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRooftopUsersQuery>
export async function getRooftopUsers(
  variables: GetRooftopUsersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRooftopUsersQuery['users'] | GetRooftopUsersQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRooftopUsersQuery>(
    GetRooftopUsersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.users
}